export const serviceOptions = [
    { '_id': 0, name: 'All' },
    { '_id': 1, name: 'Delivery' },
    { '_id': 2, name: 'Ride' },
    // { '_id': 3, name: 'Service' },
];